const es = {
  //Slogan
  "Business Intelligence for Public Procurement":
    "Inteligencia Empresarial para Compras Públicas",

  //Commons
  "All rights reserved": "Todos los derechos reservados",
  "Wait...": "Espere...",
  Search: "Buscar",
  Update: "Actualizar",
  Edit: "Editar",
  Save: "Guardar",
  and: "y",
  Next: "Siguiente",
  Continue: "Continuar",
  Finalize: "Finalizar",
  Cancel: "Cancelar",
  Back: "Atrás",
  Submit: "Enviar",
  "Loading...": "Cargando...",

  //API GATEWAY
  "Network Error": "Error de conexión",

  //User
  "Back to menu": "Regresar al menú",
  "My Account": "Mi Cuenta",
  Preferences: "Preferencias",
  Security: "Seguridad",
  "Select language": "Seleccione idioma",
  "Change Password": "Cambiar Contraseña",
  "Sign Out": "Cerrar Sesión",

  // CompleteRegister Component
  Welcome: "Bienvenid@",
  "is the business intelligence solution for public purchases with which you can explore the purchasing plans of the contracting entities, allowing you to analyze the supply and demand existing in the public sector in the simplest and most practical way you have ever imagined, helping you to identify business opportunities and to empathize with the competitive dynamics of public purchases.":
    "es la solución de inteligencia empresarial para compras públicas con la que usted puede explorar los planes de compras de las entidades contratante, permitiéndole analizar la oferta y la demanda existente en el sector público de la forma más sencilla y práctica que jamás haya imaginado, ayudándole a identificar oportunidades de negocios y a compenetrarse con la dinámica competitiva de las compras públicas.",
  "Please complete the registration": "Por favor, complete el registro",
  "Select country": "Seleccione país",
  "ruc is not valid": "ruc no es válido",

  //SignIn Component
  "Sign in to your account": "Iniciar sesión en su cuenta",
  Username: "Usuario",
  "Enter your Username": "Ingrese su nombre de usuario",
  Password: "Contraseña",
  "Enter your password": "Ingrese su contraseña",
  "Forget your password?": "Olvidó su contraseña?",
  "Reset password": "Resetear Contraseña",
  "Create account": "Crear cuenta",
  "Sign In": "Iniciar Sesión",
  "The use of this service is subject to our":
    "El uso de este servicio está sujeto a nuestros",
  "Terms of use": "Términos de uso",
  "Privacy policy": "Política de privacidad",
  "PacReport integrates with third-party identity services for the authentication and authorization of users with data encryption both in transit and at rest and that meets the requirements of HIPAA and PCI DSS, SOC, ISO / EIC 27001, ISO / EIC 27017, ISO / EIC 27018 and ISO 9001.":
    "PacReport se integra con servicios de identidades de terceros para la autenticación y autorización de usuarios con cifrado de datos tanto tanto en tránsito como en reposo y que cumple los requisitos de HIPAA y PCI DSS, SOC, ISO/EIC 27001, ISO/EIC 27017, ISO/EIC 27018 e ISO 9001.",

  //AWS Cognito API errors messages response
  "User does not exist.": "Usuario no existe",
  "Request not allowed due to security reasons.": "Solicitud no permitida por motivos de seguridad, por favor escríbanos a soporte@pac.report",
  "User is disabled.": "Hay un problema con su cuenta, por favor escríbanos a soporte@pac.report",
  "Incorrect username or password.": "Usuario o contraseña incorrecta",
  "Password reset required for the user":
    "Restablecimiento de contraseña requerido para el usuario",
  "Attempt limit exceeded, please try after some time.":
    "Se ha superado el límite de intentos, por favor intente de nuevo más tarde.",
  "Username/client id combination not found.":
    "Combinación de nombre de usuario / identificación de cliente no encontrada.",
  "User cannot be confirm. Current status is CONFIRMED":
    "El usuario ya ha sido confirmado",

  //SignUp Component
  "Create a new account": "Crear una nueva cuenta",
  Name: "Nombre",
  Email: "Email",
  "Last name": "Apellido",
  "Country Code": "Código de país",
  "Enter your phone number": "Ingrese su número de teléfono",
  Number: "Número",

  //ConfirmSignUp
  "Confirmation code has been sent to your email": "Su código de confirmación ha sido enviado a su correo electrónico",

  //ResetPassword Component
  "Check your email and copy code":
    "Copie el código que se envió a su correo electrónico",
  "Enter your new password": "Ingrese su nueva contraseña",

  //EditUser Component
  "User information": "Información del usuario",
  "Phone number": "Número de teléfono",
  "User information has been updated":
    "La información del usuario ha sido actualizada",

  //SetMFA Component
  "Multifactor Authentication Preference":
    "Preferencia de autenticación multifactor",

  "The Multi-Factor Authentication (MFA) adds an extra layer of protection on top of your user name and password.":
    "La Authentication Multi-Factor (MFA) agrega una capa adicional de protección además de su nombre de usuario y contraseña.",

  "Scan the QR Code with your phone camera or authentication app to get the MFA code.":
    "Escanee el código QR con la cámara de su teléfono o la aplicación de autenticación para obtener el código MFA.",

  "SMS text messaging (receive a code on your mobile device)":
    "Mensajes de texto SMS (reciba un código en su dispositivo móvil)",

  "One-time password (use a QR code and MFA app to save a token on your mobile device)":
    "Contraseña de un solo uso (use un código QR y una aplicación MFA para guardar un token en su dispositivo móvil)",

  "Do not enable MFA": "No habilitar MFA",

  //DashboardLayoutLeft.vue
  "Filters and Queries": "Filtros y Consultas",
  Filters: "Filtros",
  "Saved Queries": "Consultas",

  //Filter Component

  "Add Filter": "Agregar Filtro",
  "New Filter": "Nuevo Filtro",
  "Edit Filter": "Editar Filtro",
  "Update Filter": "Actualizar Filtro",
  "Delete selected": "Eliminar selecionados",
  "No filters added": "No hay filtros agregados",
  "Save Query": "Guardar Consulta",

  //Consultas Component

  "Sign In Account": "Iniciar Sesión",
  "Sign Up Account": "Registro de Cuenta",
  "No account? ": "No tiene una cuenta? ",
  "Username cannot be empty": "Su nombre de usuario no puede estar vacio",
  "User does not exist": "Usuario no existe",
  "Incorrect username or password": "Usuario o contraseña incorrecta",
  "Reset your password": "Resetear contraseña",
  "Back to Sign In": "Volver al inicio de sesión",
  "Send Code": "Enviar Código",

  "Create a username": "Crear un nombre de usuario",
  "Create a password": "Crear una contraseña",
  "Email Address": "Dirección de Email",
  "Phone Number": "Número de Teléfono",
  "Create Account": "Crear Cuenta",
  "Have an account? ": "Ya tiene una cuenta? ",
  "Sign in": "Iniciar sesión",
  "Password cannot be empty": "La Contraseña no puede estar en vacía",
  "Invalid password format": "Formato de contraseña no es válido",
  "Attribute value for phone_number must not be null":
    "El valor del atributo para número de teléfono no puede ser nulo",
  "Invalid email address format.": "Formato de correo electrónico inválido",
  "Confirm Sign Up": "Confirmar Registro",
  "Confirmation Code": "Confirmar Código",
  "Enter your code": "Ingrese su código",
  "Lost your code? ": "Perdió su código? ",
  "Resend Code": "Reenviar Código",
  Confirm: "Confirmar",
  "Invalid verification code provided, please try again.":
    "Se ha proporcionado un código de verificación no válido, inténtalo de nuevo.",
  "Sign In with Facebook": "Iniciar sesión usando Facebook",
  "Family name": "Apellido",
  "Given name": "Nombre",
  or: "o",
  "User account has expired, it must be reset by an administrator.":
    "La cuenta de usuario ha caducado, debe ser restablecida por un administrador.",
  //ForgotPassword Component
  "Code has been sent": "Su código ha sido enviado",
  "New Password": "Nueva Contraseña",
  Code: "Código",

  "User already exists": "El usuario ya existe",
  "Your password has been updated": "Su contraseña ha sido actualizada"
};

export default es;
